import type React from 'react';

import classNames from 'classnames';

import logo from '@/images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <svg viewBox='0 0 196 48' className='logo logo--wordmark' role='img'>
    <title>Mastodon</title>
    <use xlinkHref='#logo-symbol-wordmark' />
  </svg>
);

export const IconLogo: React.FC<React.ComponentPropsWithRef<'svg'>> = ({
  className,
  role = 'img',
  ...otherProps
}) => (
  <svg
    viewBox='0 0 79 79'
    className={classNames('logo logo--icon', className)}
    role={role}
    {...otherProps}
  >
    {role !== 'presentation' && <title>Mastodon</title>}
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt='Mastodon' className='logo logo--icon' />
);
